import { PersonLane } from '@app/modules/persons/appearances/types';
import { List } from '@mui/material';
import { HoverLaneSetter } from '../../shared/apply-lane-hover';
import { PersonCastOverflowRow } from './PersonCastOverflowRow';

type PersonCastOverflowListProps = {
  lanes: PersonLane[];
  hoveredLaneKey: string | null;
  onHoverLane: HoverLaneSetter;
};

/**
 * Body of the cast-cluster "+N" popover.
 *
 * Shows a scrollable list of the people that did not fit in the visible
 * avatar stack. Hovering a row highlights that person on the summary strip
 * and dims the other list rows; rows themselves are not clickable.
 */
export function PersonCastOverflowList({
  lanes,
  hoveredLaneKey,
  onHoverLane,
}: PersonCastOverflowListProps) {
  return (
    <List
      dense
      disablePadding
      sx={{ py: 0.5, maxHeight: 280, overflowY: 'auto' }}
      onMouseLeave={() => onHoverLane(null)}
    >
      {lanes.map((lane) => (
        <PersonCastOverflowRow
          key={lane.laneKey}
          lane={lane}
          dimmed={!!hoveredLaneKey && hoveredLaneKey !== lane.laneKey}
          onHover={() => onHoverLane(lane.laneKey)}
        />
      ))}
    </List>
  );
}
